import { css } from "@emotion/react";
import { Theme } from "@mui/material";

export const accountMenuStyles = {
  linkText: (theme: Theme) =>
    css({
      color: theme.palette.text.primary,
      textAlign: "initial",
    }),
  highlightedText: (theme: Theme) =>
    css({
      fontWeight: theme.typography.fontWeightBold,
    }),
  loadingButton: css({
    paddingTop: 8,
    paddingBottom: 8,
    marginRight: 8,
  }),
  newMenuItemChip: (theme: Theme) =>
    css({
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.secondary.contrastText,
      fontSize: theme.typography.pxToRem(10),
      borderRadius: "2px",
      padding: 0,
      marginLeft: "8px",
      height: "50%",
      lineHeight: theme.typography.pxToRem(10),
      "& .MuiChip-label": {
        padding: "1px 2px",
        letterSpacing: "0.2px",
        fontSize: theme.typography.pxToRem(10),
        fontWeight: theme.typography.fontWeightMedium,
      },
    }),
  initials: (theme: Theme) =>
    css({
      backgroundColor: theme.palette.secondary.light,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.pxToRem(14),
      height: 34,
      width: 34,
    }),
};
